import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AnalyticsCopilotPage from "../screens/AnalyticsCopilotPage";
import SchoolReportPage from "../screens/SchoolReportPage";

const AnalyticsCopilotRoutes: React.FC = () => (
  <Routes>
    <Route index element={<Navigate to="copilot" replace />} />
    <Route path="copilot" element={<AnalyticsCopilotPage />} />
    <Route path="school-report" element={<SchoolReportPage />} />
  </Routes>
);

export default AnalyticsCopilotRoutes;
